const absoluteTopLeft = () => `
    position: absolute;
    top: 0;
    left: 0;
`;

const absoluteTopRight = () => `
    position: absolute;
    top: 0;
    right: 0;
`;

const absoluteBottomLeft = () => `
    position: absolute;
    bottom: 0;
    left: 0;
`;

const absoluteBottomRight = () => `
    position: absolute;
    bottom: 0;
    right: 0;
`;

const relativeTopLeft = () => `
    position: relative;
    top: 0;
    left: 0;
`;

const relativeTopRight = () => `
    position: relative;
    top: 0;
    right: 0;
`;

const relativeBottomLeft = () => `
    position: relative;
    bottom: 0;
    left: 0;
`;

const relativeBottomRight = () => `
    position: relative;
    bottom: 0;
    right: 0;
`;

export {
  absoluteTopLeft,
  absoluteTopRight,
  absoluteBottomLeft,
  absoluteBottomRight,
  relativeTopLeft,
  relativeTopRight,
  relativeBottomLeft,
  relativeBottomRight,
};
